"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var currency_1 = tslib_1.__importDefault(require("./currency"));
var company_1 = tslib_1.__importDefault(require("./company"));
var production_1 = tslib_1.__importDefault(require("./production"));
var bank_1 = tslib_1.__importDefault(require("./bank"));
var BudgetResource = /** @class */ (function (_super) {
    tslib_1.__extends(BudgetResource, _super);
    function BudgetResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BudgetResource.endpoint = '/budgets';
    BudgetResource.MODEL_NAME = 'budget';
    BudgetResource.related = {
        currency: currency_1.default,
        company: company_1.default,
        production: production_1.default,
        bank: bank_1.default,
    };
    return BudgetResource;
}(base_1.default));
exports.default = BudgetResource;
//# sourceMappingURL=budget.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/budget.js
// module id = RDlf
// module chunks = 0